import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import icon from "./assets/img_empty_countdown@2x.png";
import { t } from "./i18n";
import "./Countdown.less";

const Countdown = ({ obj, isShowPc }) => {
  const { data } = obj;
  const { title, subtitle, time } = data;
  const { startedAt, endedAt } = time;
  const [duration, setDuration] = useState(null);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (endedAt) {
      if (timer) {
        clearInterval(timer);
        setTimer(null);
      }
      const timerId = setInterval(() => {
        setDuration(dayjs.duration(dayjs(endedAt).diff(dayjs())));
      }, 1000);
      setTimer(timerId);
    }
  }, [endedAt]);

  useEffect(
    () => () => {
      clearInterval(timer);
      setTimer(null);
      setDuration(null);
    },
    []
  );

  return (
    <div
      className="countdown"
      style={{
        display:
          !startedAt ||
          (startedAt &&
            endedAt &&
            dayjs(startedAt)?.isBefore(dayjs()) &&
            dayjs(endedAt)?.isAfter(dayjs()))
            ? "flex"
            : "none",
      }}
    >
      {!!title?.text?.length && (
        <h3 className="title" style={{ color: title?.color }}>
          {title?.text}
        </h3>
      )}
      {!!subtitle?.text?.length && (
        <p
          className="subtitle"
          style={{
            color: subtitle?.color,
            marginBottom: endedAt ? (isShowPc ? 24 : 20) : 16,
          }}
        >
          {subtitle?.text}
        </p>
      )}
      <div
        className="countdown-content"
        style={{ flexDirection: endedAt ? "row" : "column" }}
      >
        {endedAt ? (
          <>
            <span
              className="time"
              style={{
                color: time?.fontColor,
                background: time?.backgroundColor,
              }}
            >
              {duration?.days() || 0}
            </span>
            <span className="unit">{t("countdown.day")}</span>
            <span
              className="time"
              style={{
                color: time?.fontColor,
                background: time?.backgroundColor,
              }}
            >
              {duration?.hours() || 0}
            </span>
            <span className="unit">{t("countdown.hour")}</span>
            <span
              className="time"
              style={{
                color: time?.fontColor,
                background: time?.backgroundColor,
              }}
            >
              {duration?.minutes() || 0}
            </span>
            <span className="unit">{t("countdown.minute")}</span>
            <span
              className="time"
              style={{
                color: time?.fontColor,
                background: time?.backgroundColor,
              }}
            >
              {duration?.seconds() || 0}
            </span>
            <span className="unit">{t("countdown.second")}</span>
          </>
        ) : (
          <>
            <img src={icon} alt="" />
            <p>{t("countdown.empty")}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Countdown;
